var handleMouseMove = null;
var elementBounds = null;
var hasLeftBounds = true;

export const onElementBoundsOut = (element, outerElement, handler) => {
  if (!element) return;

  elementBounds = element.getBoundingClientRect();
  handleMouseMove = onLeaveBounds(handler);

  outerElement.addEventListener('mousemove', e => {
    handleMouseMove(e.clientX, e.clientY);
  });

  element.addEventListener('mouseleave', e => {
    handler();
  });
};

export const getState = () => hasLeftBounds;

function onEnterBounds(handler) {
  return (x, y) => {
    if (isOutsideBounds(x, y)) {
      hasLeftBounds = true;
      handleMouseMove = onLeaveBounds(handler);
      handler();
    }    
  }
}

function onLeaveBounds(handler) {
  return (x, y) => {
    if (!isOutsideBounds(x, y)) {
      hasLeftBounds = false;
      handleMouseMove = onEnterBounds(handler);
    }
  }
}

function isOutsideBounds(x, y) {
  return x < elementBounds.left ||
         x > elementBounds.right ||
         y < elementBounds.top ||
         y > elementBounds.bottom;
}


// WEBPACK FOOTER //
// ./src/components/header/onElementOut.js